export function classNames(...args) {
    const classes = [];
    args.forEach((arg) => {
        switch (typeof arg) {
            case "string":
                classes.push(arg);
                break;
            case "object":
                Object.keys(arg).forEach((key) => {
                    if (arg[key])
                        classes.push(key);
                });
                break;
        }
    });
    return classes.filter((className) => className !== "").join(" ");
}
